import pino, { type Logger } from 'pino';
import { serializeErrors } from './serializeErrors';

/**
 * Pino logger instance
 *
 * Log levels (numeric):
 * - 10: trace - Very detailed debugging
 * - 20: debug - Debugging information
 * - 30: info - Informational messages (default)
 * - 40: warn - Warnings
 * - 50: error - Errors
 * - 60: fatal - Fatal errors
 */
export const logger: Logger = pino({
  level: 'info',
  formatters: {
    log: serializeErrors
  }
});
